<template>
  <div class="border-0 m-0 p-0 bg-transparent">
    <stormy-label
      :label="label"
      :required="required"
    />
    <select
      :disabled="disabled"
      :value="modelValue"
      class="block w-full py-2 text-base rounded border-gray-300  focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50"
      :class="[modelValue === placeholderValue ? 'text-gray-400' : '', disabled ? 'bg-gray-50' : '', hasError ? ' focus:border-red-400  focus:ring-red-200 border-red-300' : 'border-gray-300 focus:border-blue-400  focus:ring-blue-200']"

      @input="onInput($event.target.value)"
    >
      <option
        v-if="placeholder"
        :value="placeholderValue"
        :disabled="!empty"
        selected
      >
        {{ placeholder }}
      </option>
      <template v-if="hasGroups">
        <optgroup
          v-for="(group,groupIndex) of hasGroups"
          :key="groupIndex"
          :label="group"
        >
          <option
            v-for="(item, index) in filteredOptions(group)"
            :key="index"
            :value="item[optionsValue]"
            :group="item.group"
            :selected="item[optionsValue] === modelValue"
          >
            {{ item[optionsName] }}
          </option>
        </optgroup>
      </template>

      <template
        v-for="(item, index) in options"
        v-else
        :key="index"
      >
        <template v-if="!onlyOptionsWithName || (onlyOptionsWithName && ![undefined, null, '', ' ',false].includes(item[optionsName]))">
          <option
            :disabled="item[optionDisabled]"
            :value="item[optionsValue]"
            :selected="item[optionsValue] === modelValue"
          >
            {{ item[optionsName] }}
          </option>
        </template>
      </template>
    </select>
  </div>
</template>

<script setup>
import { useProp } from '@/composables/useProp.js'
import { computed } from 'vue'
import { uniq } from 'lodash'

const props = defineProps({
  label: useProp(String),
  placeholder: useProp(String, '(auswählen)'),
  placeholderValue: useProp(Number, 0),
  hasError: useProp(Boolean),
  modelValue: useProp([String, Number], 0),
  optionsValue: useProp(String, 'id'),
  optionsName: useProp(String, 'name'),
  optionDisabled: useProp(String, 'disabled'),
  onlyOptionsWithName: useProp(Boolean, false),
  empty: useProp(Boolean, false),
  options: useProp(Array),
  parseValues: useProp(Boolean),
  required: useProp(Boolean),
  disabled: useProp(Boolean)
})

const emit = defineEmits(['update:modelValue', 'change'])

const hasGroups = computed(() => {
  let groups = props.options.map(item => item.group ? item.group : null)
  if (groups.length) {
    groups = groups.filter(item => item !== null)
    if (groups.length) {
      return uniq(groups)
    }
  }
  return null
})

const filteredOptions = (group) => props.options.filter(item => item.group === group)

const onInput = (value) => {
  if (props.parseValues === true) {
    value = parseInt(value)
  }
  emit('update:modelValue', value)
  emit('change', value)
}

</script>
